import React from 'react';
import { Skeleton } from '@mui/material';

/**
 * Reusable shimmer skeleton for tables / data lists.
 * Renders `rows` x `cols` shimmer cells while data loads.
 */
const TableSkeleton = ({ rows = 6, cols = 5 }) => (
    <div className="w-full">
        {Array.from({ length: rows }).map((_, r) => (
            <div
                key={r}
                className="flex items-center gap-4 px-4 py-4 border-b border-main-border"
            >
                {Array.from({ length: cols }).map((_, c) => (
                    <Skeleton
                        key={c}
                        variant="text"
                        height={22}
                        sx={{ flex: 1, borderRadius: '6px' }}
                    />
                ))}
            </div>
        ))}
    </div>
);

export default TableSkeleton;
